import { render, staticRenderFns } from "./Plano.vue?vue&type=template&id=60196e62&"
import script from "./Plano.vue?vue&type=script&lang=js&"
export * from "./Plano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports